import moment from "moment";
import MaskAndValid from "utils/maskAndValid";

const formatDateDiff = (dateDiff) => {
  if (dateDiff === -1) {
    return "0";
  } else if (dateDiff < -1) {
    return dateDiff?.toString()?.replace("-", "");
  }

  return dateDiff?.toString();
};

export default function checkSituationDays(title) {
  const dtHoje = new Date().toISOString();
  let situationDays;

  if (
    title.Situacao === "AB" &&
    (MaskAndValid.isNullOrEmpty(title.DtVencimentoProrrogado)
      ? title.DtVencimento >= dtHoje
      : title.DtVencimentoProrrogado >= dtHoje)
  ) {
    if (!MaskAndValid.isNullOrEmpty(title.DtVencimentoProrrogado)) {
      const dateA = moment(title.DtVencimentoProrrogado);
      const dateB = moment(dtHoje);
      const diff = (dateB.diff(dateA, "days") - 2)
        ?.toString()
        ?.replace("-", "");

      situationDays = diff + " dia(s) para vencer";
    } else {
      const dateA = moment(title.DtVencimento);
      const dateB = moment(dtHoje);
      const diff = (dateB.diff(dateA, "days") - 2)
        ?.toString()
        ?.replace("-", "");

      situationDays = diff + " dia(s) para vencer";
    }
  } else {
    if (
      title.Situacao === "AB" &&
      (MaskAndValid.isNullOrEmpty(title.DtVencimentoProrrogado)
        ? title.DtVencimento < dtHoje
        : title.DtVencimentoProrrogado < dtHoje)
    ) {
      if (!MaskAndValid.isNullOrEmpty(title.DtVencimentoProrrogado)) {
        const dateA = moment(dtHoje);
        const dateB = moment(title.DtVencimentoProrrogado);
        const diff = dateA.diff(dateB, "days");

        if (diff === 0) {
          situationDays = "1 dia(s) para vencer";
        } else {
          situationDays = "a " + diff + " dia(s) vencido";
        }
      } else {
        const dateA = moment(dtHoje);
        const dateB = moment(title.DtVencimento);
        const diff = dateA.diff(dateB, "days");
        if (diff === 0) {
          situationDays = "1 dia(s) para vencer";
        } else {
          situationDays = "a " + diff + " dia(s) vencido";
        }
      }
    } else if (title.Situacao === "LQ" || title.Situacao === "LS") {
      const dateA = moment(title.DtLiquidacao);
      const dateB = moment(dtHoje);
      const diff = dateB.diff(dateA, "days");

      situationDays = "a " + formatDateDiff(diff) + " dia(s) pago";
    }
  }

  return situationDays ? situationDays.toUpperCase() : "";
}
